require("core-js/modules/es.array.reduce");

!function (n, e) {
  "object" == typeof exports && "undefined" != typeof module ? e(exports, require("prop-types"), require("styled-components"), require("react")) : "function" == typeof define && define.amd ? define(["exports", "prop-types", "styled-components", "react"], e) : e((n = n || self)["react-awesome-styled-grid"] = {}, n.PropTypes, n.styled, n.React);
}(this, function (n, e, i, d) {
  "use strict";

  e = e && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  var t = "default" in i ? i.default : i,
      p = "default" in d ? d.default : d;

  function r(n) {
    return (r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
      return typeof n;
    } : function (n) {
      return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    })(n);
  }

  function u(n, e) {
    for (var t = 0; t < e.length; t++) {
      var r = e[t];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, r.key, r);
    }
  }

  function c(e, n) {
    var t,
        r = Object.keys(e);
    return Object.getOwnPropertySymbols && (t = Object.getOwnPropertySymbols(e), n && (t = t.filter(function (n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), r.push.apply(r, t)), r;
  }

  function a(o) {
    for (var n = 1; n < arguments.length; n++) {
      var i = null != arguments[n] ? arguments[n] : {};
      n % 2 ? c(Object(i), !0).forEach(function (n) {
        var e, t, r;
        e = o, r = i[t = n], t in e ? Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }) : e[t] = r;
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(o, Object.getOwnPropertyDescriptors(i)) : c(Object(i)).forEach(function (n) {
        Object.defineProperty(o, n, Object.getOwnPropertyDescriptor(i, n));
      });
    }

    return o;
  }

  function o(n) {
    return (o = Object.setPrototypeOf ? Object.getPrototypeOf : function (n) {
      return n.__proto__ || Object.getPrototypeOf(n);
    })(n);
  }

  function f(n, e) {
    return (f = Object.setPrototypeOf || function (n, e) {
      return n.__proto__ = e, n;
    })(n, e);
  }

  function s(n, e) {
    return !e || "object" != typeof e && "function" != typeof e ? function (n) {
      if (void 0 === n) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return n;
    }(n) : e;
  }

  function l(t) {
    var r = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (n) {
        return !1;
      }
    }();

    return function () {
      var n,
          e = o(t);
      return s(this, r ? (n = o(this).constructor, Reflect.construct(e, arguments, n)) : e.apply(this, arguments));
    };
  }

  function m(n, e) {
    return e = e || n.slice(0), Object.freeze(Object.defineProperties(n, {
      raw: {
        value: Object.freeze(e)
      }
    }));
  }

  function y(n, e) {
    return function (n) {
      if (Array.isArray(n)) return n;
    }(n) || function (n, e) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(n))) return;
      var t = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var u, c = n[Symbol.iterator](); !(r = (u = c.next()).done) && (t.push(u.value), !e || t.length !== e); r = !0) {
          ;
        }
      } catch (n) {
        o = !0, i = n;
      } finally {
        try {
          r || null == c.return || c.return();
        } finally {
          if (o) throw i;
        }
      }

      return t;
    }(n, e) || function (n, e) {
      if (!n) return;
      if ("string" == typeof n) return b(n, e);
      var t = Object.prototype.toString.call(n).slice(8, -1);
      "Object" === t && n.constructor && (t = n.constructor.name);
      if ("Map" === t || "Set" === t) return Array.from(n);
      if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return b(n, e);
    }(n, e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function b(n, e) {
    (null == e || e > n.length) && (e = n.length);

    for (var t = 0, r = new Array(e); t < e; t++) {
      r[t] = n[t];
    }

    return r;
  }

  function v() {
    var n = m(["\n    @media ", " {\n      ", "\n    }\n  "]);
    return v = function v() {
      return n;
    }, n;
  }

  var g = "awesomegrid",
      h = ["xs", "sm", "md", "lg", "xl"],
      x = {
    mediaQuery: "only screen",
    columns: {
      xs: 4,
      sm: 8,
      md: 8,
      lg: 12,
      xl: 12
    },
    gutterWidth: {
      xs: 1,
      sm: 1,
      md: 1.5,
      lg: 1.5,
      xl: 1.5
    },
    paddingWidth: {
      xs: 1,
      sm: 1,
      md: 1.5,
      lg: 1.5,
      xl: 1.5
    },
    container: {
      xs: "full",
      sm: "full",
      md: "full",
      lg: 90,
      xl: 90
    },
    breakpoints: {
      xs: 1,
      sm: 48,
      md: 64,
      lg: 90,
      xl: 120
    }
  },
      w = [],
      j = function j(n) {
    return JSON.stringify(n.theme && n.theme[g] || {});
  },
      O = function O(n) {
    var e = n.theme && n.theme[g] || {},
        o = a(a({}, x), e);
    return o.media = Object.keys(o.breakpoints).reduce(function (n, e) {
      var t,
          r = o.breakpoints[e];
      return n[e] = (t = [o.mediaQuery, 0 <= r && "(min-width: ".concat(r, "rem)")].filter(Boolean).join(" and "), function () {
        return i.css(v(), t, i.css.apply(void 0, arguments));
      }), n;
    }, {}), o;
  };

  function S() {
    var n = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
        e = j(n);
    if (w[0] === e) return w[1];
    var t = O(n);
    return w[0] = e, w[1] = t;
  }

  function k() {
    var n = m(["\n    background-color: #5901ad40;\n    outline: #fff solid 1px;\n  "]);
    return k = function k() {
      return n;
    }, n;
  }

  function P() {
    var n = m(["\n      ", "\n    "]);
    return P = function P() {
      return n;
    }, n;
  }

  function E() {
    var n = m(["\n    ", "\n  "]);
    return E = function E() {
      return n;
    }, n;
  }

  function T() {
    var n = m(["\n      padding-left: ", "rem;\n      padding-right: ", "rem;\n    "]);
    return T = function T() {
      return n;
    }, n;
  }

  function z() {
    var n = m(["\n    ", "\n  "]);
    return z = function z() {
      return n;
    }, n;
  }

  function C() {
    var n = m(["\n  margin-right: auto;\n  margin-left: auto;\n  max-width: 100%;\n  box-sizing: border-box;\n\n  ", "\n  \n\n  ", "\n\n  ", "\n"]);
    return C = function C() {
      return n;
    }, n;
  }

  var W = t.div(C(), function (e) {
    return i.css(z(), h.map(function (n) {
      return S(e).container[n] && S(e).media[n](T(), S(e).paddingWidth[n], S(e).paddingWidth[n]);
    }));
  }, function (e) {
    return !e.fluid && i.css(E(), h.map(function (n) {
      return S(e).container[n] && S(e).media[n](P(), "number" == typeof S(e).container[n] ? "width: ".concat(S(e).container[n], "rem;") : "width: 100%;");
    }));
  }, function (n) {
    return n.debug && i.css(k());
  });

  function A() {
    var n = m(["\n      background-color: #5901ad40;\n      outline: #fff solid 1px;\n    "]);
    return A = function A() {
      return n;
    }, n;
  }

  function R() {
    var n = m(["", ""]);
    return R = function R() {
      return n;
    }, n;
  }

  function _() {
    var n = m(["\n      ", "\n    "]);
    return _ = function _() {
      return n;
    }, n;
  }

  function N() {
    var n = m(["", ""]);
    return N = function N() {
      return n;
    }, n;
  }

  function D() {
    var n = m(["\n      ", "\n    "]);
    return D = function D() {
      return n;
    }, n;
  }

  function L() {
    var n = m(["\n         ", ";\n        \n      "]);
    return L = function L() {
      return n;
    }, n;
  }

  function q() {
    var n = m(["\n      ", "\n    "]);
    return q = function q() {
      return n;
    }, n;
  }

  function V() {
    var n = m(["\n      margin-left: -", "rem;\n      margin-right: -", "rem;\n    "]);
    return V = function V() {
      return n;
    }, n;
  }

  function B() {
    var n = m(["\n    ", "\n  "]);
    return B = function B() {
      return n;
    }, n;
  }

  function F() {
    var n = m(["\n  box-sizing: border-box;\n  display: flex;\n  flex: 1 1 auto;\n  flex-wrap: wrap;\n  \n  ", "\n\n  ", "\n\n  ", "\n  \n  ", "\n\n  ", "\n"]);
    return F = function F() {
      return n;
    }, n;
  }

  W.displayName = "Container", W.propTypes = {
    fluid: e.bool,
    children: e.node,
    debug: e.bool
  };
  var I = t.div(F(), function (e) {
    return i.css(B(), h.map(function (n) {
      return S(e).container[n] && S(e).media[n](V(), S(e).gutterWidth[n] / 2, S(e).gutterWidth[n] / 2);
    }));
  }, function (e) {
    return e.reverse && i.css(q(), Array.isArray(e.reverse) ? h.map(function (n) {
      return S(e).breakpoints[n] && S(e).media[n](L(), -1 !== e.reverse.indexOf(n) ? "\n             flex-direction: row-reverse;\n             flex-wrap: wrap-reverse;\n             " : "\n                 flex-direction: row;\n                 flex-wrap: wrap;\n               ");
    }) : "\n            flex-direction: row-reverse;\n            flex-wrap: wrap-reverse;\n          ");
  }, function (e) {
    return e.align && i.css(D(), "object" === r(e.align) ? h.map(function (n) {
      return S(e).breakpoints[n] && S(e).media[n](N(), e.align[n] && "align-items: ".concat(e.align[n]));
    }) : "align-items: ".concat(e.align, ";"));
  }, function (e) {
    return e.justify && i.css(_(), "object" === r(e.justify) ? h.map(function (n) {
      return S(e).breakpoints[n] && S(e).media[n](R(), e.justify[n] && "justify-content: ".concat(e.justify[n]));
    }) : "justify-content: ".concat(e.justify, ";"));
  }, function (n) {
    return n.debug && i.css(A());
  });
  I.displayName = "Row";
  var M = e.oneOfType([e.bool, e.array]),
      G = e.oneOfType([e.string, e.object]);

  function H() {
    var n = m(["\n    background-color: #5901ad40;\n    outline: #fff solid 1px;\n  "]);
    return H = function H() {
      return n;
    }, n;
  }

  function Q() {
    var n = m(["", ""]);
    return Q = function Q() {
      return n;
    }, n;
  }

  function U() {
    var n = m(["\n    ", "\n  "]);
    return U = function U() {
      return n;
    }, n;
  }

  function J() {
    var n = m(["", ""]);
    return J = function J() {
      return n;
    }, n;
  }

  function $() {
    var n = m(["\n    ", "\n  "]);
    return $ = function $() {
      return n;
    }, n;
  }

  function K() {
    var n = m(["\n        flex-direction: ", ";\n      "]);
    return K = function K() {
      return n;
    }, n;
  }

  function X() {
    var n = m(["\n    ", "\n  "]);
    return X = function X() {
      return n;
    }, n;
  }

  function Y() {
    var n = m(["\n    ", ";\n    "]);
    return Y = function Y() {
      return n;
    }, n;
  }

  function Z() {
    var n = m(["\n    ", "\n  "]);
    return Z = function Z() {
      return n;
    }, n;
  }

  function nn() {
    var n = m(["\n      flex: 1 1 ", "%;\n      max-width: ", "%;\n    "]);
    return nn = function nn() {
      return n;
    }, n;
  }

  function en() {
    var n = m(["\n    ", "\n  "]);
    return en = function en() {
      return n;
    }, n;
  }

  function tn() {
    var n = m(["\n      padding-right: ", "rem;\n      padding-left: ", "rem;\n    "]);
    return tn = function tn() {
      return n;
    }, n;
  }

  function rn() {
    var n = m(["\n    ", "\n  "]);
    return rn = function rn() {
      return n;
    }, n;
  }

  function on() {
    var n = m(["\n  box-sizing: border-box;\n  flex: 1 0 auto;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n  \n  ", "\n  \n  ", "\n"]);
    return on = function on() {
      return n;
    }, n;
  }

  I.propTypes = {
    reverse: M,
    align: G,
    justify: G,
    children: e.node,
    debug: e.bool
  };
  var un = t.div(on(), function (e) {
    return !e.noGutter && i.css(rn(), h.map(function (n) {
      return S(e).breakpoints[n] && S(e).media[n](tn(), S(e).gutterWidth[n] / 2, S(e).gutterWidth[n] / 2);
    }));
  }, function (e) {
    return i.css(en(), h.map(function (n) {
      return e[n] && S(e).breakpoints[n] && S(e).media[n](nn(), e[n] / S(e).columns[n] * 100, e[n] / S(e).columns[n] * 100);
    }));
  }, function (e) {
    return e.offset && i.css(Z(), h.map(function (n) {
      return S(e).breakpoints[n] && S(e).media[n](Y(), "object" === r(e.offset) ? void 0 !== e.offset[n] && "margin-left: ".concat(0 < e.offset[n] ? e.offset[n] / S(e).columns[n] * 100 : 0, "%") : "margin-left: ".concat(e.offset / S(e).columns.xs * 100, "%"));
    }));
  }, function (e) {
    return e.reverse && i.css(X(), Array.isArray(e.reverse) ? h.map(function (n) {
      return S(e).breakpoints[n] && S(e).media[n](K(), -1 !== e.reverse.indexOf(n) ? "column-reverse" : "column");
    }) : "flex-direction: column-reverse;");
  }, function (e) {
    return e.align && i.css($(), "object" === r(e.align) ? h.map(function (n) {
      return S(e).breakpoints[n] && S(e).media[n](J(), e.align[n] && "align-items: ".concat(e.align[n]));
    }) : "align-items: ".concat(e.align, ";"));
  }, function (e) {
    return e.justify && i.css(U(), "object" === r(e.justify) ? h.map(function (n) {
      return S(e).breakpoints[n] && S(e).media[n](Q(), e.justify[n] && "justify-content: ".concat(e.justify[n]));
    }) : "justify-content: ".concat(e.justify, ";"));
  }, function (n) {
    return n.debug && i.css(H());
  });
  un.displayName = "Col";
  var cn = e.oneOfType([e.string, e.number]),
      an = e.oneOfType([e.string, e.object]),
      fn = e.oneOfType([e.bool, e.object]),
      sn = e.oneOfType([e.bool, e.array]);

  function ln(e, n, t) {
    void 0 === t && (t = global);
    var r = d.useRef();
    d.useEffect(function () {
      r.current = n;
    }, [n]), d.useEffect(function () {
      if (t && t.addEventListener) {
        var n = function n(_n) {
          return r.current(_n);
        };

        return t.addEventListener(e, n), function () {
          t.removeEventListener(e, n);
        };
      }
    }, [e, t]);
  }

  function dn() {
    return "undefined" != typeof window && window.innerWidth ? window.innerWidth : null;
  }

  function pn() {
    var n,
        e = h,
        t = S(0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {}).breakpoints,
        r = "undefined" != typeof window && window.getComputedStyle(document.querySelector("html")).getPropertyValue("font-size").replace("px", "") || 16,
        o = Object.values(t).map(function (n) {
      return n * r;
    }),
        i = dn();
    return i && (n = e[0], o[1] && i >= o[1] && (n = e[1]), o[2] && i >= o[2] && (n = e[2]), o[3] && i >= o[3] && (n = e[3]), o[4] && i >= o[4] && (n = e[4])), n;
  }

  un.propTypes = {
    xs: cn,
    sm: cn,
    md: cn,
    lg: cn,
    xl: cn,
    align: an,
    justify: an,
    offSet: fn,
    reverse: sn,
    noGutter: e.bool,
    children: e.node,
    debug: e.bool
  };

  function mn(n) {
    function e() {
      var n = pn({
        theme: c
      });
      s !== n && l(n);
    }

    var t = n.xs,
        r = n.sm,
        o = n.md,
        i = n.lg,
        u = n.xl,
        c = n.theme,
        a = n.children,
        f = y(d.useState("xs"), 2),
        s = f[0],
        l = f[1];
    return d.useEffect(function () {
      e();
    }, []), ln("orientationchange", e), ln("resize", e), !function () {
      switch (s) {
        case "xs":
          return t;

        case "sm":
          return r;

        case "md":
          return o;

        case "lg":
          return i;

        case "xl":
          return u;
      }
    }() && p.createElement(p.Fragment, null, a);
  }

  var yn = {
    xs: !(mn.displayName = "Hidden"),
    sm: !1,
    md: !1,
    lg: !1,
    xl: !1,
    children: null,
    theme: {}
  },
      bn = {
    xs: e.bool,
    sm: e.bool,
    md: e.bool,
    lg: e.bool,
    xl: e.bool,
    theme: e.object,
    children: e.node
  };
  mn.defaultProps = yn, mn.propTypes = bn;

  function vn(n) {
    function e() {
      var n = pn({
        theme: c
      });
      s !== n && l(n);
    }

    var t = n.xs,
        r = n.sm,
        o = n.md,
        i = n.lg,
        u = n.xl,
        c = n.theme,
        a = n.children,
        f = y(d.useState("xs"), 2),
        s = f[0],
        l = f[1];
    return d.useEffect(function () {
      e();
    }, []), ln("orientationchange", e), ln("resize", e), !!function () {
      switch (s) {
        case "xs":
          return t;

        case "sm":
          return r;

        case "md":
          return o;

        case "lg":
          return i;

        case "xl":
          return u;
      }
    }() && p.createElement(p.Fragment, null, a);
  }

  var gn = i.withTheme(mn);
  vn.displayName = "Visible", vn.defaultProps = yn, vn.propTypes = bn;

  var hn = i.withTheme(vn),
      xn = function () {
    !function (n, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
      n.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: n,
          writable: !0,
          configurable: !0
        }
      }), e && f(n, e);
    }(o, d.Component);
    var n,
        e,
        t,
        r = l(o);

    function o() {
      var t;
      return function (n, e) {
        if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
      }(this, o), (t = r.call(this)).setScreen = function () {
        var n = t.state.screen,
            e = pn(t.props);
        n && n === e || (n = e, t.setState({
          screen: e
        }));
      }, t.state = {
        screen: "xs"
      }, t;
    }

    return n = o, (e = [{
      key: "componentDidMount",
      value: function value() {
        this.setScreen(), "undefined" != typeof window && (window.addEventListener("orientationchange", this.setScreen, !1), window.addEventListener("resize", this.setScreen, !1));
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        window.removeEventListener("orientationchange", this.setScreen), window.removeEventListener("resize", this.setScreen);
      }
    }, {
      key: "render",
      value: function value() {
        var n = this.props.render;
        return p.createElement(p.Fragment, null, n && n(this.state.screen));
      }
    }]) && u(n.prototype, e), t && u(n, t), o;
  }();

  xn.defaultProps = {
    theme: {}
  }, xn.displayName = "ScreenClass", xn.propTypes = {
    render: e.func
  };
  var wn = i.withTheme(xn);

  function jn() {
    var n = m(["\n      ::before {\n        content: '", "'\n      }\n    "]);
    return jn = function jn() {
      return n;
    }, n;
  }

  function On() {
    var n = m(["\n    ", "\n  "]);
    return On = function On() {
      return n;
    }, n;
  }

  function Sn() {
    var n = m(["\n    z-index: 10;\n    position: fixed;\n    font-size: 1.5rem;\n    font-weight: bold;\n    right: 10px;\n    bottom: 10px;\n    width: 50px;\n    height: 30px;\n    background-color: #5901ad40;\n    display: flex;\n    border-radius: 5px;\n    justify-content: center;\n    align-items: center;\n  ", "\n"]);
    return Sn = function Sn() {
      return n;
    }, n;
  }

  var kn = t.div(Sn(), function (e) {
    return i.css(On(), h.map(function (n) {
      return S(e).breakpoints[n] && S(e).media[n](jn(), n);
    }));
  });
  kn.displayName = "ScreenBadge";
  var Pn = {
    getScreenClass: pn,
    getViewPort: dn
  };
  n.Col = un, n.Container = W, n.Hidden = gn, n.Row = I, n.ScreenBadge = kn, n.ScreenClass = wn, n.Visible = hn, n.config = S, n.util = Pn, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});